import { classNames } from "primereact/utils";
import styles from "./Link.module.scss";
import { Link } from "react-router-dom";

interface ILinkProps {
  className?: string;
  label: string;
  to?: string;
  onClick?: () => void;
}

export const AppLink = ({ className, label, to, onClick }: ILinkProps) => {
  const isLink = Boolean(to);

  return isLink ? (
    <Link className={classNames(styles.link, className)} to={to!}>
      {label}
    </Link>
  ) : (
    <a
      className={classNames(styles.link, className)}
      onClick={onClick}
      type="button"
    >
      {label}
    </a>
  );
};
